module.exports = __webpack_public_path__ + "img/pro-photo13.f5d9cb54.jpg";